/**
 * GM Shop — Judge.me : avatars en initiales + liens en accent GM.
 * Les médailles / badges trust ne sont pas modifiés (comportement Judge.me par défaut).
 */
(function () {
  'use strict';

  var ACCENT_FALLBACK = '#7cc4ff';
  var MARKER = 'data-gm-jdgm-initial';

  var PALETTE = [
    { bg: 'linear-gradient(135deg, #1f3a8a, #3b6ed1)', fg: '#dbeaff' },
    { bg: 'linear-gradient(135deg, #0b2a55, #2363b0)', fg: '#e6f1ff' },
    { bg: 'linear-gradient(135deg, #1d4a7a, #4b95c9)', fg: '#eaf6ff' },
    { bg: 'linear-gradient(135deg, #2b3a6e, #6a86d6)', fg: '#ecf0ff' },
    { bg: 'linear-gradient(135deg, #0d3b66, #4178b8)', fg: '#e6f1ff' },
    { bg: 'linear-gradient(135deg, #143b6b, #5fa8d3)', fg: '#eaf6ff' },
  ];

  function accent() {
    try {
      var v = getComputedStyle(document.documentElement).getPropertyValue('--gm-accent').trim();
      if (v) return v;
    } catch (e) {
      /* ignore */
    }
    return ACCENT_FALLBACK;
  }

  function hashCode(str) {
    var h = 0;
    if (!str) return 0;
    for (var i = 0; i < str.length; i++) {
      h = (h << 5) - h + str.charCodeAt(i);
      h |= 0;
    }
    return Math.abs(h);
  }

  function pickPalette(name) {
    var idx = hashCode(name || 'anon') % PALETTE.length;
    return PALETTE[idx];
  }

  function initialsFromName(name) {
    if (!name) return '?';
    var clean = String(name)
      .replace(/[\u{1F300}-\u{1FAFF}\u{1F000}-\u{1F2FF}\u{2600}-\u{27BF}]/gu, '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!clean) return '?';
    if (/^anonyme$/i.test(clean) || /^anonymous$/i.test(clean)) return '?';

    var parts = clean.split(/[\s\-_.]+/).filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    var first = parts[0] || clean;
    return first.substring(0, 2).toUpperCase();
  }

  function isRealUserPhoto(img) {
    if (!img || !img.src) return false;
    var src = img.src;
    if (!/^https?:/i.test(src)) return false;
    if (/judge\.me|judgeme|jdgm|cdn01\.judge|cdn-s3\.judge/i.test(src)) return false;
    if (/data:image\/svg/i.test(src)) return false;
    return true;
  }

  function findAuthorName(reviewRoot) {
    if (!reviewRoot) return '';
    var sel = [
      '.jdgm-rev__author',
      '.jdgm-rev__author-wrapper .jdgm-rev__author',
      '.jdgm-rev__author-wrapper',
    ];
    for (var i = 0; i < sel.length; i++) {
      var el = reviewRoot.querySelector(sel[i]);
      if (el) {
        var t = el.textContent.replace(/\s+/g, ' ').trim();
        if (t) return t;
      }
    }
    return '';
  }

  function buildInitialNode(name) {
    var p = pickPalette(name);
    var span = document.createElement('span');
    span.className = 'gm-jdgm-initial';
    span.textContent = initialsFromName(name);
    span.style.cssText =
      'display:flex;align-items:center;justify-content:center;' +
      'width:100%;height:100%;border-radius:50%;' +
      'background:' +
      p.bg +
      ';color:' +
      p.fg +
      ';' +
      'font-family:Inter,system-ui,sans-serif;' +
      'font-weight:700;font-size:13px;letter-spacing:0.02em;' +
      'text-transform:uppercase;line-height:1;user-select:none;';
    return span;
  }

  /** Tous les shadow roots sous .jdgm-widget (les mutations internes ne remontent pas au document). */
  function getAllJdgmShadowRoots() {
    var roots = [];
    function add(sr) {
      if (!sr || roots.indexOf(sr) !== -1) return;
      roots.push(sr);
      try {
        sr.querySelectorAll('*').forEach(function (el) {
          if (el.shadowRoot) add(el.shadowRoot);
        });
      } catch (e) {
        /* ignore */
      }
    }
    try {
      document.querySelectorAll('.jdgm-widget, [id^="judgeme-"], [id*="judge_me"]').forEach(function (w) {
        if (w.shadowRoot) add(w.shadowRoot);
      });
      document.querySelectorAll('[class*="jdgm"]').forEach(function (el) {
        if (el.shadowRoot) add(el.shadowRoot);
      });
    } catch (e) {
      /* ignore */
    }
    return roots;
  }

  var shadowObserved = new WeakSet();

  var ICON_SELECTOR = '.jdgm-rev__icon';

  function queryReviewIcons(root) {
    if (!root || !root.querySelectorAll) return [];
    return [].slice.call(root.querySelectorAll(ICON_SELECTOR));
  }

  function forEachReviewIcon(fn) {
    queryReviewIcons(document).forEach(fn);
    getAllJdgmShadowRoots().forEach(function (sr) {
      queryReviewIcons(sr).forEach(fn);
    });
  }

  function fixIcon(icon) {
    if (!icon) return;

    var img = icon.querySelector('img');
    if (img && isRealUserPhoto(img)) {
      if (icon.querySelector('.gm-jdgm-initial')) {
        while (icon.firstChild) icon.removeChild(icon.firstChild);
        icon.appendChild(img);
      }
      icon.classList.remove('gm-jdgm-has-initial');
      icon.setAttribute(MARKER, '1');
      return;
    }

    if (icon.querySelector('.gm-jdgm-initial')) {
      return;
    }

    var hex = accent();
    icon.style.setProperty('background-image', 'none', 'important');
    icon.style.setProperty('color', hex, 'important');

    var review = icon.closest('.jdgm-rev') || icon.parentElement;
    var name = findAuthorName(review);
    var node = buildInitialNode(name);

    while (icon.firstChild) icon.removeChild(icon.firstChild);
    icon.appendChild(node);
    icon.classList.add('gm-jdgm-has-initial');
    icon.setAttribute(MARKER, '1');
  }

  function isPurpleish(rgb) {
    if (!rgb) return false;
    var m = rgb.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (!m) return false;
    var r = parseInt(m[1], 10);
    var g = parseInt(m[2], 10);
    var b = parseInt(m[3], 10);
    if (r === 0 && g === 0 && b === 0) return false;
    if (r === 255 && g === 255 && b === 255) return false;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var sat = max === 0 ? 0 : (max - min) / max;
    return b > 70 && r > 80 && (r + b) / 2 > g + 18 && sat > 0.18;
  }

  /** Menu tri des avis (Judge.me) : ne pas forcer la couleur d’accent sur les options. */
  function inJdgmSortMenu(el) {
    if (!el || !el.closest) return false;
    if (el.closest(
      '.jdgm-sort-dropdown-wrapper, .jdgm-rev-widg__sort-wrapper, ' +
        '[class*="jdgm-sort-dropdown"][class*="menu"], ' +
        '[class*="jdgm-sort-dropdown__list"], ' +
        '[class*="jdgm-sort-dropdown__options"], ' +
        '[class*="jdgm-sort-dropdown__popover"], ' +
        '[class*="jdgm-sort-dropdown__panel"]'
    )) {
      return true;
    }
    var cn = el.className && String(el.className);
    if (cn && /jdgm-sort-dropdown/i.test(cn) && !/jdgm-sort-dropdown-wrapper/i.test(cn)) {
      return true;
    }
    return false;
  }

  function recolorLinks() {
    var hex = accent();
    document
      .querySelectorAll(
        '.jdgm-rev-widg__title a, .jdgm-rev-widg__title-row a, .jdgm-rev-widg__header a, ' +
          '.jdgm-rev-widg .jdgm-rev-widg__title-wrapper a'
      )
      .forEach(function (a) {
        try {
          if (a.closest && a.closest('.jdgm-write-rev-link, .jdgm-rev-widg__write-review-btn')) return;
          if (inJdgmSortMenu(a)) return;
          a.style.setProperty('color', hex, 'important');
          a.style.setProperty('-webkit-text-fill-color', hex, 'important');
          a.style.setProperty('text-decoration', 'none', 'important');
          a.style.setProperty('border-bottom', 'none', 'important');
        } catch (e) {
          /* ignore */
        }
      });

    document
      .querySelectorAll(
        '.jdgm-widget a, .jdgm-rev-widg a, .jdgm-all-reviews-text, ' +
          '[class*="all-reviews"], [class*="see-all"], [class*="all-reviews-link"]'
      )
      .forEach(function (a) {
        try {
          if (a.closest && a.closest('.jdgm-write-rev-link, .jdgm-rev-widg__write-review-btn')) return;
          if (inJdgmSortMenu(a)) return;
          var c = getComputedStyle(a).color;
          var cn = a.className || '';
          var jdgmClassMatch =
            /all-reviews|see-all/i.test(cn) || (/jdgm/i.test(cn) && !/jdgm-sort/i.test(cn));
          if (
            isPurpleish(c) ||
            jdgmClassMatch ||
            /judge\.me/i.test(a.getAttribute('href') || '') ||
            /\/pages\/.*review|#judgeme|judgeme-reviews/i.test(a.getAttribute('href') || '')
          ) {
            a.style.setProperty('color', hex, 'important');
            a.style.setProperty('-webkit-text-fill-color', hex, 'important');
            a.style.setProperty('text-decoration-color', hex, 'important');
          }
        } catch (e) {
          /* ignore */
        }
      });

    document.querySelectorAll('.jdgm-widget a').forEach(function (a) {
      try {
        if (a.closest && a.closest('.jdgm-write-rev-link, .jdgm-rev-widg__write-review-btn')) return;
        if (inJdgmSortMenu(a)) return;
        var t = (a.textContent || '').replace(/\s+/g, ' ').trim();
        if (
          /voir\s+tous\s+les\s+avis/i.test(t) ||
          /see\s+all\s+reviews/i.test(t) ||
          /tous\s+les\s+avis/i.test(t)
        ) {
          a.style.setProperty('color', hex, 'important');
          a.style.setProperty('-webkit-text-fill-color', hex, 'important');
          a.style.setProperty('text-decoration-color', hex, 'important');
        }
      } catch (e) {
        /* ignore */
      }
    });

    document.querySelectorAll('.jdgm-widget, .jdgm-widget *').forEach(function (el) {
      try {
        if (!el.children || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') return;
        if (inJdgmSortMenu(el)) return;
        if (
          el.closest &&
          el.closest(
            '.jdgm-medal-wrapper, .jdgm-medals-wrapper, .jdgm-medals-section, .jdgm-all-reviews-rating-wrapper, [class*="jdgm-all-reviews-rating"]'
          )
        ) {
          return;
        }
        var c = getComputedStyle(el).color;
        if (isPurpleish(c)) {
          el.style.setProperty('color', hex, 'important');
        }
      } catch (e) {
        /* ignore */
      }
    });
  }

  /**
   * Judge.me force violet / blanc sur le tri. On harmonise pilule + panneau porté (y compris portail).
   */
  function applySortDropdownFixes() {
    var hex = accent();
    /** Texte des lignes non sélectionnées sur panneau sombre (lisible, pas bleu pâle). */
    var MENU_OPTION = 'rgba(232, 240, 255, 0.93)';
    var PANEL_SHADOW =
      '0 28px 64px rgba(2, 8, 24, 0.65), 0 12px 32px rgba(2, 8, 24, 0.35), 0 0 0 1px rgba(124, 196, 255, 0.12)';

    function hasBlueSelectionBg(el) {
      var p = el;
      for (var i = 0; i < 4 && p; i++) {
        try {
          var bg = getComputedStyle(p).backgroundColor;
          var m = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
          if (m) {
            var r = parseInt(m[1], 10);
            var g = parseInt(m[2], 10);
            var b = parseInt(m[3], 10);
            if (b > 160 && r < 120 && g < 170) return true;
            if (g > 130 && g > r && g > b && r < 120) return true;
          }
        } catch (e) {
          /* ignore */
        }
        p = p.parentElement;
      }
      return false;
    }

    function paintOptionLike(node) {
      var cn = (node.className && String(node.className)) || '';
      var selected =
        node.getAttribute('aria-selected') === 'true' ||
        (node.classList && (node.classList.contains('jdgm--active') || node.classList.contains('jdgm--selected'))) ||
        /selected|active|highlight/i.test(cn) ||
        hasBlueSelectionBg(node);
      if (selected) {
        node.style.setProperty('color', '#ffffff', 'important');
        node.style.setProperty('-webkit-text-fill-color', '#ffffff', 'important');
      } else {
        node.style.setProperty('color', MENU_OPTION, 'important');
        node.style.setProperty('-webkit-text-fill-color', MENU_OPTION, 'important');
      }
    }

    function processRoot(root) {
      if (!root || !root.querySelectorAll) return;

      root.querySelectorAll('.jdgm-sort-dropdown-wrapper, .jdgm-rev-widg__sort-wrapper').forEach(function (wrap) {
        var trig = wrap.querySelector('button.jdgm-sort-dropdown, .jdgm-sort-dropdown');
        if (trig) {
          trig.style.setProperty('--jdgm-primary-color', hex, 'important');
          trig.style.setProperty(
            'background',
            'linear-gradient(180deg, rgba(32, 44, 82, 0.92), rgba(18, 26, 52, 0.96))',
            'important'
          );
          trig.style.setProperty('border', '1px solid rgba(148, 176, 255, 0.28)', 'important');
          trig.style.setProperty('color', hex, 'important');
          trig.style.setProperty('-webkit-text-fill-color', hex, 'important');
          trig.querySelectorAll('span, div, p').forEach(function (ch) {
            ch.style.setProperty('color', hex, 'important');
            ch.style.setProperty('-webkit-text-fill-color', hex, 'important');
          });
        }
        var arrow = wrap.querySelector('.jdgm-sort-dropdown-arrow');
        if (arrow) {
          arrow.style.setProperty('color', hex, 'important');
          arrow.style.setProperty('-webkit-text-fill-color', hex, 'important');
        }

        wrap.querySelectorAll('ul, ol, [role="listbox"], [role="menu"]').forEach(function (panel) {
          if (trig && panel.contains(trig)) return;
          panel.style.setProperty('--jdgm-primary-color', MENU_OPTION, 'important');
          panel.style.setProperty(
            'background',
            'linear-gradient(165deg, rgba(24, 32, 58, 0.98), rgba(12, 17, 36, 0.99))',
            'important'
          );
          panel.style.setProperty('background-color', 'rgba(19, 26, 48, 0.97)', 'important');
          panel.style.setProperty('backdrop-filter', 'blur(14px)', 'important');
          panel.style.setProperty('-webkit-backdrop-filter', 'blur(14px)', 'important');
          panel.style.setProperty('box-shadow', PANEL_SHADOW, 'important');
          panel.style.setProperty('border-radius', '14px', 'important');
          panel.style.setProperty('border', '1px solid rgba(148, 176, 255, 0.22)', 'important');
          panel.style.setProperty('z-index', '10050', 'important');
          panel.querySelectorAll('*').forEach(function (node) {
            if (!node.tagName || node.tagName === 'SVG' || node.tagName === 'STYLE') return;
            if (trig && (node === trig || trig.contains(node))) return;
            if (node.classList && node.classList.contains('jdgm-sort-dropdown')) return;
            if (node.classList && node.classList.contains('jdgm-sort-dropdown-arrow')) return;
            paintOptionLike(node);
          });
        });

        wrap.querySelectorAll('li, [role="option"], [role="menuitem"]').forEach(function (opt) {
          if (opt.classList && opt.classList.contains('jdgm-sort-dropdown')) return;
          if (opt.classList && opt.classList.contains('jdgm-sort-dropdown-arrow')) return;
          if (opt.closest && opt.closest('button.jdgm-sort-dropdown')) return;
          paintOptionLike(opt);
          opt.querySelectorAll('span, a, div').forEach(function (sub) {
            if (sub.classList && sub.classList.contains('jdgm-sort-dropdown')) return;
            paintOptionLike(sub);
          });
        });

      });

      root.querySelectorAll('[class*="jdgm-sort-dropdown"]').forEach(function (el) {
        var cn = String(el.className || '');
        if (!/menu|options|list|popover|panel|Menu|Options|List/i.test(cn)) return;
        el.style.setProperty('--jdgm-primary-color', MENU_OPTION, 'important');
        el.style.setProperty(
          'background',
          'linear-gradient(165deg, rgba(24, 32, 58, 0.98), rgba(12, 17, 36, 0.99))',
          'important'
        );
        el.style.setProperty('background-color', 'rgba(19, 26, 48, 0.97)', 'important');
        el.style.setProperty('backdrop-filter', 'blur(14px)', 'important');
        el.style.setProperty('-webkit-backdrop-filter', 'blur(14px)', 'important');
        el.style.setProperty('box-shadow', PANEL_SHADOW, 'important');
        el.style.setProperty('border-radius', '14px', 'important');
        el.style.setProperty('border', '1px solid rgba(148, 176, 255, 0.22)', 'important');
        el.style.setProperty('z-index', '10050', 'important');
        el.querySelectorAll('*').forEach(function (node) {
          if (node.classList && node.classList.contains('jdgm-sort-dropdown')) return;
          if (node.classList && node.classList.contains('jdgm-sort-dropdown-arrow')) return;
          if (!node.tagName || node.tagName === 'STYLE') return;
          paintOptionLike(node);
        });
      });
    }

    processRoot(document);
    getAllJdgmShadowRoots().forEach(processRoot);
  }

  function jdgmDebugLog() {
    try {
      if (!/\bgm_jdgm_debug=1\b/.test(location.search || '') && !sessionStorage.getItem('gm_jdgm_debug')) {
        return;
      }
      var widgets = document.querySelectorAll('.jdgm-widget');
      console.warn('[GM Shop / Judge.me diagnostic] .jdgm-widget :', widgets.length);
      if (widgets.length === 0) {
        console.warn('  → Option : coller assets/gm-judgeme-admin-paste.css dans Judge.me > Custom CSS.');
      }
    } catch (e) {
      /* ignore */
    }
  }

  function scan() {
    forEachReviewIcon(fixIcon);
    getAllJdgmShadowRoots().forEach(function (sr) {
      if (shadowObserved.has(sr)) return;
      shadowObserved.set(sr, true);
      try {
        obs.observe(sr, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class', 'aria-expanded', 'aria-selected', 'hidden'],
        });
      } catch (e) {
        /* ignore */
      }
    });
    recolorLinks();
    applySortDropdownFixes();
    requestAnimationFrame(jdgmDebugLog);
    jdgmDebugLog();
  }

  var t;
  function debounced() {
    clearTimeout(t);
    /* 0 ms : même frame que les mutations Judge.me — évite le délai visible vs le CSS. */
    t = setTimeout(scan, 0);
  }

  var obs = new MutationObserver(debounced);

  if (document.body) {
    obs.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'aria-expanded', 'aria-selected', 'hidden'],
    });
  } else {
    document.addEventListener('DOMContentLoaded', function bodyObs() {
      obs.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'aria-expanded', 'aria-selected', 'hidden'],
      });
      scan();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener(
    'load',
    function (e) {
      var imgEl = e.target;
      if (!imgEl || imgEl.tagName !== 'IMG') return;
      if (!imgEl.closest || !imgEl.closest('.jdgm-widget, .jdgm-rev-widg, [class*="jdgm"]')) return;
      debounced();
    },
    true
  );
  window.addEventListener('load', debounced);
  window.addEventListener('resize', debounced);

  [180, 450, 1100, 2400, 5000, 8000, 12000].forEach(function (ms) {
    setTimeout(scan, ms);
  });

  var pollN = 0;
  var pollId = setInterval(function () {
    scan();
    pollN++;
    if (pollN >= 100) {
      clearInterval(pollId);
    }
  }, 500);
})();
